(function () {
  function init() {
    document.querySelectorAll('.monian-kit-scent:not([data-ready])').forEach(function (box) {
      box.dataset.ready = 'true';
      var select = box.querySelector('select');
      var options = box.querySelector('.monian-scent-options');
      if (!select || !options) return;
      options.hidden = false;
      select.classList.add('monian-select-fallback');
      options.addEventListener('click', function (event) {
        var button = event.target.closest('[data-kit-scent]');
        if (!button) return;
        select.value = button.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      select.addEventListener('change', function () {
        var button = Array.from(options.querySelectorAll('[data-kit-scent]')).find(function (item) { return item.dataset.value === select.value; });
        if (!button) return;
        options.querySelectorAll('button').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        box.querySelector('.monian-selected strong').textContent = button.dataset.name;
        box.querySelector('.monian-selected span').textContent = button.dataset.notes;
        document.querySelectorAll('[data-kit-sticky-scent]').forEach(function (label) { label.textContent = button.dataset.kitScent.charAt(0).toUpperCase() + button.dataset.kitScent.slice(1) + ' · Change scent ↑'; });
        var image = document.getElementById('monian-kit-main');
        if (image) { image.src = button.dataset.image; image.alt = 'ScentPause Incense Gift Set — ' + button.dataset.name + '. Gift packaging and gift bag included.'; image.dataset.mediaKind = 'main'; }
        document.querySelectorAll('.gallery-thumb[data-monian-image]').forEach(function (thumb, index) {
          thumb.setAttribute('aria-pressed', String(index === 0));
          if (index === 0) { thumb.dataset.monianImage = button.dataset.image; thumb.dataset.alt = image ? image.alt : button.dataset.name; thumb.setAttribute('aria-label', 'View ' + button.dataset.name + ' gift set'); var smallImage = thumb.querySelector('img'); if (smallImage) { smallImage.src = button.dataset.image; smallImage.removeAttribute('srcset'); smallImage.alt = thumb.dataset.alt; } }
        });
        var heroThumb = document.querySelector('.monian-gallery [data-monian-image]');
        if (heroThumb) heroThumb.click();
      });
    });
  }
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-monian-image], [data-monian-video]');
    if (thumb) {
      var gallery = thumb.closest('.monian-gallery');
      var image = document.getElementById('monian-kit-main');
      var video = gallery && gallery.querySelector('.monian-gallery-video');
      var caption = gallery && gallery.querySelector('.image-caption');
      if (caption && !caption.dataset.originalCaption) caption.dataset.originalCaption = caption.textContent;
      if (thumb.dataset.monianVideo && video) {
        if (video.getAttribute('src') !== thumb.dataset.monianVideo) video.src = thumb.dataset.monianVideo;
        video.poster = thumb.dataset.poster || ''; video.muted = true; video.hidden = false;
        gallery.dataset.activeMedia = 'video';
        if (caption) caption.textContent = thumb.dataset.alt;
        video.play().catch(function () {});
      } else {
        if (video) { video.pause(); video.hidden = true; }
        if (gallery) gallery.dataset.activeMedia = 'image';
        if (caption) caption.textContent = caption.dataset.originalCaption;
        if (image) { image.src = thumb.dataset.monianImage; image.alt = thumb.dataset.alt; image.dataset.mediaKind = thumb.dataset.kind; }
      }
      if (gallery) gallery.querySelectorAll('[data-monian-image], [data-monian-video]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === thumb)); });
    }
    var choice = event.target.closest('.monian-p3 .choose-from-guide, [data-scent-shortcut]');
    if (choice) {
      var option = document.querySelector('[data-kit-scent="' + choice.dataset.scent + '"]');
      if (option) { option.click(); var guide = choice.closest('.monian-scent-guide'); if (guide) guide.open = false; option.focus({ preventScroll: true }); document.getElementById('monian-kit-purchase').scrollIntoView({ block: 'center' }); }
    }
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

(function(){
 var help=document.querySelector('.monian-mobile-help'),fallback=document.getElementById('monian-help-fallback');
 if(!help)return;
 var host,activator;
 function connect(){
  host=document.querySelector('shopify-chat');
  var runtime=host&&host.shadowRoot&&host.shadowRoot.querySelector('shopify-agent-runtime');
  activator=runtime&&runtime.shadowRoot&&runtime.shadowRoot.querySelector('button[part="activator"]');
  if(!activator)return false;
  function sync(){var open=activator.getAttribute('aria-expanded')==='true';host.dataset.monianNav=open?'open':'closed';help.setAttribute('aria-expanded',String(open||!fallback.hidden));}
  sync();new MutationObserver(sync).observe(activator,{attributes:true,attributeFilter:['aria-expanded']});return true;
 }
 var attempts=0,timer=setInterval(function(){if(connect()||++attempts>30)clearInterval(timer);},500);
 help.addEventListener('click',function(event){
  event.stopPropagation();
  connect();
  if(activator&&host){fallback.hidden=false;help.setAttribute('aria-expanded','true');host.dataset.monianNav='open';requestAnimationFrame(function(){if(activator.getAttribute('aria-expanded')!=='true')activator.click();});}
  else{fallback.hidden=!fallback.hidden;help.setAttribute('aria-expanded',String(!fallback.hidden));}
 });
 document.querySelector('.monian-close-help').addEventListener('click',function(){fallback.hidden=true;help.setAttribute('aria-expanded','false');help.focus();});
 document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!fallback.hidden){fallback.hidden=true;help.setAttribute('aria-expanded','false');help.focus();}});
})();

/* Mobile purchase bar delegates to the existing native product form. */
(function () {
  function initSticky() {
    document.querySelectorAll('[data-kit-sticky]:not([data-ready])').forEach(function (bar) {
      var button = bar.querySelector('[data-kit-buy]');
      var scentSelect = document.querySelector('.monian-kit-scent select');
      var form = document.getElementById(button.dataset.form || (scentSelect && scentSelect.getAttribute('form')));
      var submit = form && form.querySelector('[name="add"]');
      if (!submit) return;
      bar.dataset.ready = 'true';
      bar.hidden = false;
      function sync() {
        button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        button.textContent = (submit.classList.contains('loading') || submit.classList.contains('btn-loading')) ? 'Adding…' : (button.disabled ? 'Unavailable' : 'Add gift set');
      }
      sync();
      new MutationObserver(sync).observe(submit, {attributes:true, attributeFilter:['disabled','aria-disabled','class']});
      button.addEventListener('click', function () { if (!button.disabled) submit.click(); });
    });
  }
  initSticky();
  document.addEventListener('shopify:section:load', initSticky);
})();

/* Accessible gallery arrows reuse the existing image/selection behavior. */
(function () {
 function initGallery() {
  document.querySelectorAll('.monian-gallery:not([data-gallery-ready])').forEach(function (gallery) {
   var thumbs=Array.from(gallery.querySelectorAll('[data-monian-image], [data-monian-video]'));
   var count=gallery.querySelector('[data-monian-count]');
   if(thumbs.length<2||!count)return;
   gallery.dataset.galleryReady='true';
   gallery.querySelectorAll('[data-monian-step]').forEach(function(b){b.hidden=false;});count.hidden=false;
   function sync(){var n=thumbs.findIndex(function(t){return t.getAttribute('aria-pressed')==='true';});count.textContent=(Math.max(0,n)+1)+' / '+thumbs.length;}
   function step(delta){var n=thumbs.findIndex(function(t){return t.getAttribute('aria-pressed')==='true';});var thumb=thumbs[(Math.max(0,n)+delta+thumbs.length)%thumbs.length];thumb.click();var rail=gallery.querySelector('.gallery-thumbs-row');if(rail){var left=thumb.offsetLeft-rail.offsetLeft;if(left<rail.scrollLeft)rail.scrollLeft=left;else if(left+thumb.offsetWidth>rail.scrollLeft+rail.clientWidth)rail.scrollLeft=left+thumb.offsetWidth-rail.clientWidth;}sync();}
   gallery.querySelectorAll('[data-monian-step]').forEach(function(b){b.addEventListener('click',function(){step(Number(b.dataset.monianStep));});});
   gallery.addEventListener('keydown',function(e){if(e.target.tagName==='VIDEO')return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();step(e.key==='ArrowRight'?1:-1);}});
   thumbs.forEach(function(t){new MutationObserver(sync).observe(t,{attributes:true,attributeFilter:['aria-pressed']});});sync();
  });
 }
 initGallery();document.addEventListener('shopify:section:load',initGallery);
})();

/* Gift notes are public Shopify line-item properties, sent through the native product form. */
(function () {
 function initGifts() {
  document.querySelectorAll('[data-gift-card]:not([data-gift-ready])').forEach(function(box){
   var dialog=box.querySelector('dialog'),opener=box.querySelector('[data-gift-open]');
   if(!dialog||typeof dialog.showModal!=='function')return;
   box.dataset.giftReady='true';
   var title=box.querySelector('[data-gift-title]'),message=box.querySelector('[data-gift-message]');
   var titleProperty=box.querySelector('[data-gift-title-property]'),messageProperty=box.querySelector('[data-gift-message-property]');
   var status=box.querySelector('[data-gift-status]');
   var receipt=box.querySelector('[data-gift-receipt]'),receiptProperty=box.querySelector('[data-gift-receipt-property]');
   function close(){dialog.close();opener.focus({preventScroll:true});}
   function save(){
    titleProperty.value=title.value.trim();messageProperty.value=message.value.trim();
    titleProperty.disabled=!titleProperty.value;messageProperty.disabled=!messageProperty.value;
    if(receipt&&receiptProperty)receiptProperty.value=receipt.checked?'Gift receipt (no prices)':'Standard invoice (prices shown)';
    status.hidden=titleProperty.disabled&&messageProperty.disabled&&!(receipt&&receipt.checked);
    status.textContent=status.hidden?'':(!titleProperty.disabled||!messageProperty.disabled?'Card saved. ':'')+(receipt&&receipt.checked?'Gift receipt selected — no prices.':'Standard invoice — prices shown.');
    opener.querySelector('.monian-gift-open-note').textContent=status.hidden?'Card & gift receipt +':'Edit gift options';
    titleProperty.dispatchEvent(new Event('change',{bubbles:true}));messageProperty.dispatchEvent(new Event('change',{bubbles:true}));
    close();
   }
   opener.addEventListener('click',function(){title.value=titleProperty.value;message.value=messageProperty.value;if(receipt&&receiptProperty)receipt.checked=receiptProperty.value==='Gift receipt (no prices)';dialog.showModal();title.focus();});
   box.querySelector('[data-gift-save]').addEventListener('click',save);
   box.querySelector('[data-gift-remove]').addEventListener('click',function(){title.value='';message.value='';save();});
   box.querySelector('[data-gift-cancel]').addEventListener('click',close);
   dialog.addEventListener('cancel',function(e){e.preventDefault();close();});
   dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
   title.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();message.focus();}});
   dialog.addEventListener('keydown',function(e){e.stopPropagation();});
  });
 }
 document.addEventListener('click',function(e){var button=e.target.closest('[data-gift-delivery]');if(!button)return;var details=Array.from(document.querySelectorAll('details')).find(function(d){var s=d.querySelector('summary');return s&&s.textContent.includes('Shipping & returns');});if(details){details.open=true;details.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});details.querySelector('summary').focus({preventScroll:true});}});
 initGifts();document.addEventListener('shopify:section:load',initGifts);
})();
/* Conservative standard-order estimate: Pacific date, weekends and U.S. federal holidays excluded. */
(function () {
 function nthWeekday(year,month,weekday,n){var d=new Date(Date.UTC(year,month,1));return 1+(weekday-d.getUTCDay()+7)%7+7*(n-1);}
 function holiday(date){
  var year=date.getUTCFullYear(),key=date.toISOString().slice(0,10),days=[];
  function add(y,m,d){days.push(new Date(Date.UTC(y,m,d)).toISOString().slice(0,10));}
  [year-1,year,year+1].forEach(function(y){
   [[0,1],[5,19],[6,4],[10,11],[11,25]].forEach(function(md){var d=new Date(Date.UTC(y,md[0],md[1]));add(y,md[0],md[1]);if(d.getUTCDay()===6)add(y,md[0],md[1]-1);if(d.getUTCDay()===0)add(y,md[0],md[1]+1);});
   [[0,1,3],[1,1,3],[8,1,1],[9,1,2],[10,4,4]].forEach(function(x){add(y,x[0],nthWeekday(y,x[0],x[1],x[2]));});
   var last=new Date(Date.UTC(y,5,0));add(y,4,last.getUTCDate()-(last.getUTCDay()+6)%7);
  });
  return days.indexOf(key)!==-1;
 }
 function plusBusinessDays(start,count){var d=new Date(start.getTime());while(count>0){d.setUTCDate(d.getUTCDate()+1);if(d.getUTCDay()!==0&&d.getUTCDay()!==6&&!holiday(d))count--;}return d;}
 function initDelivery(){
  var parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
  function part(name){return Number(parts.find(function(p){return p.type===name;}).value);}
  var today=new Date(Date.UTC(part('year'),part('month')-1,part('day')));
  document.querySelectorAll('[data-monian-delivery-date]').forEach(function(el){
   if(el.dataset.available!=='true'){el.textContent='Currently unavailable. Delivery estimates resume when this set is available.';return;}
   if(el.dataset.special==='true'||el.dataset.inStock!=='true'){el.textContent='Special or preorder items: dispatch in 7–14 business days, plus transit. Contact us before ordering for a gift date.';return;}
   var arrival=plusBusinessDays(today,10),label=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:arrival.getUTCFullYear()!==today.getUTCFullYear()?'numeric':undefined,timeZone:'UTC'}).format(arrival);
   el.textContent='Order today: estimated delivery by '+label+'. Includes processing; not guaranteed. Special orders excluded.';
  });
 }
 initDelivery();document.addEventListener('shopify:section:load',initDelivery);document.addEventListener('visibilitychange',function(){if(!document.hidden)initDelivery();});
})();

/* Keep supporting copy within the primary Add to Cart button edges. */
(function(){
  function alignPurchaseNotes(){
    document.querySelectorAll('.monian-p3-kit .monian-shipping-note').forEach(function(note){
      if(note.dataset.purchaseNoteAligned)return;
      var root=note.closest('.bls__product-details-infor');
      var button=root&&root.querySelector('.product-form__submit');
      if(!button)return;
      note.dataset.purchaseNoteAligned='true';
      var pending=false;
      function update(){
        pending=false;
        if(!note.isConnected||!button.isConnected){if(observer)observer.disconnect();return;}
        var rect=button.getBoundingClientRect(), parent=note.parentElement.getBoundingClientRect();
        if(!rect.width||!parent.width)return;
        var offset=Math.max(0,rect.left-parent.left);
        note.style.setProperty('--monian-purchase-note-offset',offset+'px');
        note.style.setProperty('--monian-purchase-note-width',Math.min(rect.width,Math.max(0,parent.width-offset))+'px');
      }
      function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
      var observer=window.ResizeObserver?new ResizeObserver(schedule):null;
      if(observer){observer.observe(button);observer.observe(root);}
      else window.addEventListener('resize',schedule);
      schedule();
      if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',alignPurchaseNotes);else alignPurchaseNotes();
  document.addEventListener('shopify:section:load',alignPurchaseNotes);
})();
